module.exports = __webpack_public_path__ + "img/topimg.7c92fb05.svg";